import React, { useState } from 'react';
import { Box, Container, ToggleButton, ToggleButtonGroup } from '@mui/material';
// removed format/fr as title was removed
import MonthView from './MonthView';
import WeekView from './WeekView';

type ViewType = 'month' | 'week';

const Calendar: React.FC = () => {
  const [view, setView] = useState<ViewType>('month');
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newView: ViewType | null
  ) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ my: 4 }}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 3 }}>
          <ToggleButtonGroup
            value={view}
            exclusive
            onChange={handleViewChange}
            aria-label="vue calendrier"
          >
            <ToggleButton value="month" aria-label="vue mensuelle">
              Mois
            </ToggleButton>
            <ToggleButton value="week" aria-label="vue hebdomadaire">
              Semaine
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
        
        {view === 'month' ? (
          <MonthView 
            currentDate={currentDate} 
            onDateChange={setCurrentDate}
            dialogOpen={dialogOpen}
            setDialogOpen={setDialogOpen}
          />
        ) : (
          <WeekView 
            currentDate={currentDate}
            onDateChange={setCurrentDate}
            dialogOpen={dialogOpen}
            setDialogOpen={setDialogOpen}
          />
        )}
      </Box>
    </Container>
  );
};

export default Calendar; 